import React from "react";
import { Api_EndPoints } from "../../utils/Api_EndPoints";
import { useMutation } from "@tanstack/react-query";
import http_payroll from "../../utils/http_payroll";

const updateDepartment = async (input) => {
  const data = await http_payroll.put(
    Api_EndPoints.AddDepartment,
    input
  );
  
  console.log(data)
  return data;
};

export const useUpdateDepartmentMutation = () => {
  return useMutation({
    mutationFn: updateDepartment,
  });
};
